export default __webpack_public_path__ + "static/media/comingSoon_station_icon.bd39a992.png";